import './styles.scss';
import {Tooltip} from 'react-tooltip';
import OpenItems from './CustomRows/OpenItems';
import ClosedItems from './CustomRows/ClosedItems';
import MissedInspections from './CustomRows/MissedInspections';
import ReturnServiceInspections from './CustomRows/ReturnServiceInspections';
import OutOfService from './CustomRows/OutOfService';
import GracePeriod from './CustomRows/GracePeriod';
import React from 'react';
import CustomPaginate from '../PaginateComponent';
import FBOCustomRow from '../Corporate/CorporateDashboardCard/FBOCustomRow';
import CustomLoader from '../CustomLoader/CustomLoader';
import ReportRows from '../../pages/Report/ReportRows';
import { useTranslation } from '../../hooks/useTranslation';

const Table = ({
  headers = [],
  rows = [],
  cellKeys = [], // Array of cell keys to get value from row object
  // TODO: Don't forget to add CustomRows same keys with customRowType.
  // TODO: Double check default rows if you're adding customRows. It will remove default row's styles and children etc. Add gridTemplateColumns and toolTip for sure!!!
  customRowType = null,
  withPagination = false,
  page,
  handlePageClick,
  isSmallPaddings = false,
  isLoading = false,
  currentPage,
  ...props
}) => {
  const {t} = useTranslation();
  return (
    <table className='table'>
      {!!rows?.length && (
        <thead
          className='table-head'
          style={{
            gridTemplateColumns: `repeat(${headers.length}, 1fr)`,
          }}
        >
          {headers.map((header, index) => (
            <th
              key={index}
              className='table-th'
              style={{padding: isSmallPaddings && '10px'}}
            >
              {header}
            </th>
          ))}
        </thead>
      )}
      {!!rows?.length ? (
        <tbody className='table-body'>
          {rows?.map((row, rowIndex) => (
            <Rows
              action={row}
              cellKeys={cellKeys}
              customRowType={customRowType}
              rowIndex={rowIndex}
              isSmallPaddings={isSmallPaddings}
              {...props}
            />
          ))}
        </tbody>
      ) : (
        <div className='facility__table-empty'>
          <img src='/assets/icons/facility-empty.svg' alt='empty' />
          <p>{t('table.noData')}</p>
        </div>
      )}
      {withPagination && (
        <CustomPaginate
          pageCount={page}
          handlePageClick={handlePageClick}
          currentPage={currentPage}
        />
      )}
    </table>
  );
};

export default Table;

export const DefaultCell = ({value, index, rowIndex}) => {
  // Checking valid values
  if (typeof value !== ('string' || 'number')) {
    return '';
  }

  return (
    <>
      <td key={index} className='table-cell'>
        <span data-tooltip-id={`toolTip-${index}-${rowIndex}-${value}`}>
          {value}
        </span>
        <Tooltip
          place='top'
          noArrow
          id={`toolTip-${index}-${rowIndex}-${value}`}
          content={value}
        />
      </td>
    </>
  );
};

const Rows = props => {
  // TODO: If you add new custom row add Component to conditions with new key
  const conditions = {
    // Corrective Actions rows
    open_items: <OpenItems {...props} />,
    closed_items: <ClosedItems {...props} />,
    missed_inspections: <MissedInspections {...props} />,
    service_inspections: <ReturnServiceInspections {...props} />,
    out_of_service: <OutOfService {...props} />,
    grace_period: <GracePeriod {...props} />,
    fbo_custom_row: <FBOCustomRow {...props} />,
    reports_row: <ReportRows {...props} />,
  };

  if (!conditions[props.customRowType]) {
    return (
      <tr
        key={props.rowIndex}
        className='table-row'
        style={{
          gridTemplateColumns: `repeat(${props.cellKeys.length}, 1fr)`,
        }}
      >
        {props.cellKeys.map((key, index) => (
          <DefaultCell
            value={props.action[key]}
            index={index}
            rowIndex={props.rowIndex}
          />
        ))}
      </tr>
    );
  }

  return conditions[props.customRowType];
};
